export const RESPONSE = {
  200: 'Success',
  201: 'Created',
  400: 'Bad Request',
  401: 'Session Expired', //Unauthorized
  403: 'Forbidden',
  404: 'Not Found',
  405: 'Method Not Allowed',
  409: 'Conflict',
  500: "Something went wrong, but we're already on it", //Internal Server Error
  0: 'Something Went Wrong',
};
